module.exports = require('react/lib/shallowCompare');


//////////////////
// WEBPACK FOOTER
// ../~/react-addons-shallow-compare/index.js
// module id = 85
// module chunks = 3